export default {
    url: '/detail/:id',
    template: `<survey-detail
                    survey-group="vm.surveyGroup"
                    classifiers="vm.classifiers"
                    sites="vm.sites"
                    company="vm.company"></survey-detail>`,
    resolve: {
        surveyGroup ($stateParams, SurveyGroupResource) {
            return SurveyGroupResource.get({ id: $stateParams.id, expand: 'formActiveI18n,sortedByNameParticipants,users,surveyGroupI18ns,activeI18n' }).$promise;
        },
        classifiers: (ClassifierResource) => ClassifierResource.query({ pageSize: 0 }).$promise,
        sites: (SiteResource) => SiteResource.query({ surveySites: true, pageSize: 0 }).$promise,
        company (CompanyResource, TokenService) {
            return CompanyResource.publicView({ id: TokenService.getCompanyId(), expand: 'companySurveyI18ns' }).$promise;
        }
    },
    controller (surveyGroup, classifiers, sites, company) {
        this.surveyGroup = surveyGroup;
        this.classifiers = classifiers;
        this.sites = sites;
        this.company = company;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/survey/detail/index.js